module.exports = __webpack_public_path__ + "img/reducir.954d7777.svg";